<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="d-flex align-center">
            <v-icon left class="mr-2">mdi-account-group</v-icon>
            Asignación de Cupos - Incentivo al Retiro
            <v-spacer />
            <v-btn
              v-if="esSubdere"
              color="success"
              class="mr-2"
              :loading="exportando"
              @click="exportarExcel"
            >
              <v-icon left>mdi-microsoft-excel</v-icon>
              Descargar Excel
            </v-btn>
          </v-card-title>

          <!-- Filtros -->
          <v-card-text>
            <!-- Fila 1: Estado, Municipalidad, RUT -->
            <v-row>
              <v-col cols="12" md="3">
                <v-select
                  v-model="filtros.estado"
                  :items="estadosDisponibles"
                  label="Estado"
                  clearable
                  outlined
                  dense
                  hide-details
                  @change="cargarBeneficiarios"
                />
              </v-col>
              <v-col v-if="esSubdere" cols="12" md="5">
                <v-autocomplete
                  v-model="filtros.municipalidad_id"
                  :items="municipalidades"
                  item-text="nombre"
                  item-value="id"
                  label="Municipalidad"
                  clearable
                  outlined
                  dense
                  hide-details
                  @change="cargarBeneficiarios"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="filtros.rut"
                  label="Buscar por RUT"
                  clearable
                  outlined
                  dense
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  @keyup.enter="cargarBeneficiarios"
                  @click:clear="filtros.rut = null; cargarBeneficiarios()"
                />
              </v-col>
            </v-row>

            <!-- Fila 2: Año, Proceso, Prelación, Sector, Ordenar -->
            <v-row class="mt-2">
              <v-col cols="12" md="1">
                <v-text-field
                  v-model.number="filtros.anio_postulacion"
                  label="Año"
                  type="number"
                  clearable
                  outlined
                  dense
                  hide-details
                  @keyup.enter="cargarBeneficiarios"
                  @click:clear="filtros.anio_postulacion = null; cargarBeneficiarios()"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="filtros.tipo_proceso"
                  :items="tiposProceso"
                  label="Proceso"
                  clearable
                  outlined
                  dense
                  hide-details
                  @change="cargarBeneficiarios"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="filtros.prelacion_min"
                  label="Prelación desde"
                  clearable
                  outlined
                  dense
                  hide-details
                  @keyup.enter="cargarBeneficiarios"
                  @click:clear="filtros.prelacion_min = null; cargarBeneficiarios()"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="filtros.prelacion_max"
                  label="Prelación hasta"
                  clearable
                  outlined
                  dense
                  hide-details
                  @keyup.enter="cargarBeneficiarios"
                  @click:clear="filtros.prelacion_max = null; cargarBeneficiarios()"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="filtros.sector"
                  :items="sectoresDisponibles"
                  label="Sector"
                  clearable
                  outlined
                  dense
                  hide-details
                  @change="cargarBeneficiarios"
                />
              </v-col>
              <v-col cols="auto" class="d-flex align-center">
                <v-btn
                  small
                  outlined
                  :color="filtros.ordenar_prelacion ? 'primary' : 'default'"
                  @click="toggleOrdenPrelacion"
                >
                  <v-icon left small>mdi-sort-calendar-ascending</v-icon>
                  Ordenar por fecha nac. y RUT
                </v-btn>
              </v-col>
              <v-spacer />
              <v-col cols="auto" class="d-flex align-center">
                <v-btn
                  small
                  outlined
                  :loading="cargando"
                  @click="cargarBeneficiarios"
                >
                  <v-icon left small>mdi-refresh</v-icon>
                  Refrescar
                </v-btn>
              </v-col>
            </v-row>

            <!-- Barra de selección y acciones masivas -->
            <template v-if="esSubdere && seleccionadas.length > 0">
              <v-divider class="my-3" />
              <v-row align="center">
                <v-col cols="auto">
                  <v-chip color="primary">
                    {{ seleccionadas.length }} seleccionada(s)
                  </v-chip>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="orange darken-1"
                    dark
                    small
                    class="mr-2"
                    @click="abrirModalProceso('lista_espera')"
                  >
                    <v-icon left small>mdi-format-list-numbered</v-icon>
                    Pasar a Lista de Espera
                  </v-btn>
                  <v-btn
                    color="blue"
                    dark
                    small
                    class="mr-2"
                    @click="abrirModalProceso('beneficiario')"
                  >
                    <v-icon left small>mdi-account-arrow-right</v-icon>
                    Pasar a Beneficiario
                  </v-btn>
                  <v-btn
                    color="green"
                    dark
                    small
                    @click="abrirModalProceso('pagado')"
                  >
                    <v-icon left small>mdi-cash-check</v-icon>
                    Pasar a Pagado
                  </v-btn>
                </v-col>
                <v-spacer />
                <v-col cols="auto" class="d-flex align-center">
                  <v-text-field
                    v-model.number="seleccionarPrimeras"
                    label="Seleccionar primeras"
                    type="number"
                    outlined
                    dense
                    hide-details
                    style="max-width: 180px;"
                    class="mr-2"
                    min="1"
                  />
                  <v-btn
                    outlined
                    small
                    :disabled="!seleccionarPrimeras || seleccionarPrimeras < 1"
                    @click="seleccionarPrimerasN"
                  >
                    Seleccionar
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </v-card-text>

          <v-divider />

          <!-- Tabla de beneficiarios -->
          <v-data-table
            v-model="seleccionadas"
            :headers="headers"
            :items="beneficiarios"
            :loading="cargando"
            :server-items-length="totalBeneficiarios"
            :options.sync="opciones"
            :footer-props="{
              'items-per-page-options': [15, 30, 50, 100, 500, 1000],
            }"
            :show-select="esSubdere"
            item-key="id"
            class="elevation-0"
            @update:options="cargarBeneficiarios"
            @click:row="irAlDetalle"
          >
            <!-- RUT -->
            <template #[`item.rut`]="{ item }">
              <router-link
                :to="{ name: 'asignacion-beneficiario-detalle', params: { id: item.id } }"
                class="text-decoration-none"
              >
                <strong>{{ item.rut }}</strong>
              </router-link>
            </template>

            <!-- Nombre -->
            <template #[`item.nombre_completo`]="{ item }">
              {{ item.nombre_completo || getNombreCompleto(item) }}
            </template>

            <!-- Municipalidad -->
            <template #[`item.municipalidad`]="{ item }">
              {{ getMunicipalidadNombre(item) }}
            </template>

            <!-- Sector -->
            <template #[`item.sector`]="{ item }">
              <v-chip x-small :color="getSectorColor(item.sector)">
                {{ getSectorTexto(item.sector) }}
              </v-chip>
            </template>

            <!-- Estado -->
            <template #[`item.estado`]="{ item }">
              <v-chip
                :color="getEstadoColor(item.estado)"
                small
                dark
              >
                {{ getEstadoTexto(item.estado) }}
              </v-chip>
            </template>

            <!-- Prelación -->
            <template #[`item.numero_prelacion`]="{ item }">
              {{ item.numero_prelacion || '-' }}
            </template>

            <!-- Fecha de nacimiento -->
            <template #[`item.fecha_nacimiento`]="{ item }">
              {{ formatearFecha(item.fecha_nacimiento) }}
            </template>

            <!-- Acciones -->
            <template #[`item.acciones`]="{ item }">
              <v-btn
                icon
                small
                :to="{ name: 'asignacion-beneficiario-detalle', params: { id: item.id } }"
              >
                <v-icon small>mdi-eye</v-icon>
              </v-btn>
            </template>

            <!-- Sin datos -->
            <template #no-data>
              <div class="text-center py-5">
                <v-icon size="64" color="grey lighten-2">
                  mdi-account-group-outline
                </v-icon>
                <p class="text-h6 grey--text mt-3">
                  No hay beneficiarios en la etapa de asignación
                </p>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ═══ Modal: Proceso Lista de Espera ═══ -->
    <v-dialog v-model="modalListaEspera.visible" max-width="700" persistent>
      <v-card>
        <v-card-title>
          <v-icon left>mdi-format-list-numbered</v-icon>
          Proceso Lista de Espera
        </v-card-title>
        <v-card-text>
          <!-- Validación de estado -->
          <v-alert v-if="modalListaEspera.erroresEstado.length > 0" type="error" text dense class="mb-3">
            {{ modalListaEspera.erroresEstado.length }} postulación(es) no están en estado
            <strong>Validada</strong> o no cumplen requisitos y serán excluidas.
          </v-alert>
          <v-alert type="info" text dense class="mb-3">
            {{ modalListaEspera.validas }} postulación(es) válidas serán asignadas a Lista de Espera
            con número de prelación correlativo.
          </v-alert>

          <v-select
            v-model="modalListaEspera.tipoProceso"
            :items="tiposProceso"
            label="Tipo de proceso"
            outlined
            dense
          />

          <!-- Preview -->
          <template v-if="modalListaEspera.preview">
            <v-divider class="mb-3" />
            <v-chip color="success" small class="mb-2">
              {{ modalListaEspera.preview.total }} postulaciones con prelación asignada
            </v-chip>
            <v-simple-table dense class="mb-3" style="max-height: 300px; overflow-y: auto;">
              <thead>
                <tr>
                  <th>N. Prelación</th>
                  <th>RUT</th>
                  <th>Nombre</th>
                  <th>Fecha Nacimiento</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="p in modalListaEspera.preview.postulaciones" :key="p.id">
                  <td><strong>{{ p.numero_prelacion }}</strong></td>
                  <td>{{ p.rut }}</td>
                  <td>{{ p.nombre_completo }}</td>
                  <td>{{ formatearFecha(p.fecha_nacimiento) }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarModal('lista_espera')">Cancelar</v-btn>
          <v-btn
            v-if="!modalListaEspera.preview"
            color="primary"
            text
            :loading="modalListaEspera.cargando"
            :disabled="!modalListaEspera.tipoProceso || modalListaEspera.validas === 0 || modalListaEspera.erroresEstado.length > 0"
            @click="previewProceso('lista_espera')"
          >
            Vista previa
          </v-btn>
          <v-btn
            v-if="modalListaEspera.preview"
            color="primary"
            text
            :loading="modalListaEspera.ejecutando"
            @click="ejecutarProceso('lista_espera')"
          >
            Ejecutar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ═══ Modal: Proceso Beneficiario ═══ -->
    <v-dialog v-model="modalBeneficiario.visible" max-width="800" persistent>
      <v-card>
        <v-card-title>
          <v-icon left>mdi-account-arrow-right</v-icon>
          Pasar a Beneficiario
        </v-card-title>
        <v-card-text>
          <!-- Validación de estado -->
          <v-alert v-if="modalBeneficiario.erroresEstado.length > 0" type="error" text dense class="mb-3">
            {{ modalBeneficiario.erroresEstado.length }} postulación(es) no están en estado
            <strong>Lista de Espera</strong> o no cumplen requisitos y serán excluidas.
          </v-alert>

          <!-- Contexto de filtros activos -->
          <v-alert type="info" text dense class="mb-3">
            Se procesarán postulaciones en estado <strong>Lista de Espera</strong>
            <span v-if="filtros.tipo_proceso"> · Proceso: <strong>{{ filtros.tipo_proceso }}</strong></span>
            <span v-if="filtros.prelacion_min || filtros.prelacion_max"> · Prelación:
              <strong>{{ filtros.prelacion_min || '00001' }}</strong> – <strong>{{ filtros.prelacion_max || '(sin límite)' }}</strong>
            </span>
          </v-alert>

          <v-subheader class="px-0">Resolución Lista de Espera</v-subheader>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="modalBeneficiario.form.resolucion_lista_espera_numero"
                label="Número de resolución"
                outlined
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-menu v-model="menuFechaResLE" :close-on-content-click="false" offset-y min-width="auto">
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="modalBeneficiario.form.resolucion_lista_espera_fecha"
                    label="Fecha de resolución"
                    readonly outlined dense v-bind="attrs" v-on="on"
                  />
                </template>
                <v-date-picker v-model="modalBeneficiario.form.resolucion_lista_espera_fecha" @input="menuFechaResLE = false" />
              </v-menu>
            </v-col>
          </v-row>

          <v-subheader class="px-0">Resolución Beneficiario</v-subheader>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="modalBeneficiario.form.resolucion_beneficiario_numero"
                label="Número de resolución"
                outlined
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-menu v-model="menuFechaResBen" :close-on-content-click="false" offset-y min-width="auto">
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="modalBeneficiario.form.resolucion_beneficiario_fecha"
                    label="Fecha de resolución"
                    readonly outlined dense v-bind="attrs" v-on="on"
                  />
                </template>
                <v-date-picker v-model="modalBeneficiario.form.resolucion_beneficiario_fecha" @input="menuFechaResBen = false" />
              </v-menu>
            </v-col>
          </v-row>

          <v-subheader class="px-0">Publicación Diario Oficial</v-subheader>
          <v-row>
            <v-col cols="6">
              <v-menu v-model="menuFechaDO" :close-on-content-click="false" offset-y min-width="auto">
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="modalBeneficiario.form.fecha_publicacion_diario_oficial"
                    label="Fecha de publicación"
                    readonly outlined dense v-bind="attrs" v-on="on"
                  />
                </template>
                <v-date-picker v-model="modalBeneficiario.form.fecha_publicacion_diario_oficial" @input="menuFechaDO = false" />
              </v-menu>
            </v-col>
          </v-row>

          <!-- Preview -->
          <template v-if="modalBeneficiario.preview">
            <v-divider class="mb-3" />
            <v-alert v-if="modalBeneficiario.preview.errores.length > 0" type="error" text dense class="mb-3">
              {{ modalBeneficiario.preview.errores.length }} postulación(es) no pudieron procesarse y serán excluidas. No se puede proceder mientras haya errores.
            </v-alert>
            <v-chip color="success" small class="mb-2">
              {{ modalBeneficiario.preview.total }} postulaciones serán cambiadas a Beneficiario
            </v-chip>
            <v-simple-table dense class="mb-3" style="max-height: 300px; overflow-y: auto;">
              <thead>
                <tr>
                  <th>N. Prelación</th>
                  <th>RUT</th>
                  <th>Nombre</th>
                  <th>Municipalidad</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="p in modalBeneficiario.preview.postulaciones" :key="p.id">
                  <td><strong>{{ p.numero_prelacion }}</strong></td>
                  <td>{{ p.rut }}</td>
                  <td>{{ p.nombre_completo }}</td>
                  <td>{{ getMunicipalidadNombrePorId(p.municipalidad_id) }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarModal('beneficiario')">Cancelar</v-btn>
          <v-btn
            v-if="!modalBeneficiario.preview"
            color="primary"
            text
            :loading="modalBeneficiario.cargando"
            :disabled="!modalBeneficiarioValido || modalBeneficiario.erroresEstado.length > 0"
            @click="previewProceso('beneficiario')"
          >
            Vista previa
          </v-btn>
          <v-btn
            v-if="modalBeneficiario.preview"
            color="primary"
            text
            :loading="modalBeneficiario.ejecutando"
            :disabled="modalBeneficiario.preview.errores.length > 0"
            @click="ejecutarProceso('beneficiario')"
          >
            Ejecutar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ═══ Modal: Proceso Pagado ═══ -->
    <v-dialog v-model="modalPagado.visible" max-width="700" persistent>
      <v-card>
        <v-card-title>
          <v-icon left>mdi-cash-check</v-icon>
          Pasar a Pagado
        </v-card-title>
        <v-card-text>
          <!-- Validación de estado -->
          <v-alert v-if="modalPagado.erroresEstado.length > 0" type="error" text dense class="mb-3">
            {{ modalPagado.erroresEstado.length }} postulación(es) no están en estado
            <strong>Cese Confirmado</strong> o <strong>Fallecimiento Confirmado</strong> o no cumplen requisitos y serán excluidas.
          </v-alert>
          <v-subheader class="px-0">Archivo Excel de prelaciones</v-subheader>
          <v-row>
            <v-col cols="12">
              <v-file-input
                v-model="modalPagado.archivo"
                label="Subir Excel (col 1: número prelación, col 2: proceso)"
                accept=".xlsx,.xls"
                outlined
                dense
                prepend-icon="mdi-microsoft-excel"
                @change="modalPagado.preview = null"
              />
            </v-col>
          </v-row>

          <v-subheader class="px-0">Resolución de Pago</v-subheader>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="modalPagado.form.resolucion_pago_numero"
                label="Número de resolución"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-menu v-model="menuFechaResPago" :close-on-content-click="false" offset-y min-width="auto">
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="modalPagado.form.resolucion_pago_fecha"
                    label="Fecha de resolución"
                    readonly outlined dense v-bind="attrs" v-on="on"
                  />
                </template>
                <v-date-picker v-model="modalPagado.form.resolucion_pago_fecha" @input="menuFechaResPago = false" />
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-menu v-model="menuFechaPago" :close-on-content-click="false" offset-y min-width="auto">
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="modalPagado.form.fecha_pago"
                    label="Fecha de pago / transferencia"
                    readonly outlined dense v-bind="attrs" v-on="on"
                  />
                </template>
                <v-date-picker v-model="modalPagado.form.fecha_pago" @input="menuFechaPago = false" />
              </v-menu>
            </v-col>
          </v-row>

          <!-- Preview -->
          <template v-if="modalPagado.preview">
            <v-divider class="mb-3" />
            <div class="d-flex mb-3" style="gap: 8px;">
              <v-chip color="primary" small>
                {{ modalPagado.preview.total_leidas }} filas leídas
              </v-chip>
              <v-chip color="success" small>
                {{ modalPagado.preview.total }} válidas → Pagado
              </v-chip>
              <v-chip v-if="modalPagado.preview.errores.length > 0" color="error" small>
                {{ modalPagado.preview.errores.length }} con error
              </v-chip>
            </div>

            <!-- Tabla de postulaciones válidas -->
            <template v-if="modalPagado.preview.postulaciones.length > 0">
              <v-simple-table dense class="mb-3" style="max-height: 200px; overflow-y: auto;">
                <thead>
                  <tr>
                    <th>N. Prelación</th>
                    <th>RUT</th>
                    <th>Nombre</th>
                    <th>Municipalidad</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="p in modalPagado.preview.postulaciones" :key="p.id">
                    <td><strong>{{ p.numero_prelacion }}</strong></td>
                    <td>{{ p.rut }}</td>
                    <td>{{ p.nombre_completo }}</td>
                    <td>{{ getMunicipalidadNombrePorId(p.municipalidad_id) }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </template>

            <!-- Tabla de errores -->
            <template v-if="modalPagado.preview.errores.length > 0">
              <v-alert type="error" text dense class="mb-2">
                No se puede proceder mientras haya errores. Corrija el archivo Excel y vuelva a subirlo.
              </v-alert>
              <v-simple-table dense style="max-height: 150px; overflow-y: auto;">
                <thead>
                  <tr>
                    <th>Fila / Prelación</th>
                    <th>Proceso</th>
                    <th>Error</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(e, idx) in modalPagado.preview.errores" :key="idx" class="red lighten-5">
                    <td>{{ e.fila ? 'Fila ' + e.fila : e.numero_prelacion }}</td>
                    <td>{{ e.tipo_proceso || '-' }}</td>
                    <td class="red--text text--darken-2">{{ e.error }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </template>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarModal('pagado')">Cancelar</v-btn>
          <v-btn
            v-if="!modalPagado.preview"
            color="primary"
            text
            :loading="modalPagado.cargando"
            :disabled="!modalPagado.archivo || modalPagado.erroresEstado.length > 0"
            @click="previewProceso('pagado')"
          >
            Vista previa
          </v-btn>
          <v-btn
            v-if="modalPagado.preview"
            color="primary"
            text
            :loading="modalPagado.ejecutando"
            :disabled="modalPagado.preview.errores.length > 0 || !modalPagadoValido"
            @click="ejecutarProceso('pagado')"
          >
            Ejecutar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { apiClient } from '@/admin/services/API'
import { format } from 'date-fns'
import { notificar, notificarErrorResponse } from '@/admin/utils/notificar'
import municipalidades from '@/plugins/municipalidades'

const ESTADOS_REQUERIDOS = {
  lista_espera: { estados: ['validada'], label: 'Validada', requiereCumple: true },
  beneficiario: { estados: ['lista_espera'], label: 'Lista de Espera', requiereCumple: true },
  pagado: { estados: ['cese_confirmado', 'fallecimiento_confirmado'], label: 'Cese/Fallecimiento Confirmado', requiereCumple: true },
}

export default {
  name: 'AsignacionBeneficiariosListado',
  data() {
    return {
      beneficiarios: [],
      seleccionadas: [],
      seleccionarPrimeras: null,
      cargando: false,
      exportando: false,
      totalBeneficiarios: 0,
      opciones: {},
      filtros: {
        estado: null,
        sector: null,
        rut: null,
        municipalidad_id: null,
        tipo_proceso: null,
        anio_postulacion: null,
        prelacion_min: null,
        prelacion_max: null,
        ordenar_prelacion: false,
      },
      municipalidades: [],
      // Date picker menus
      menuFechaResLE: false,
      menuFechaResBen: false,
      menuFechaDO: false,
      menuFechaResPago: false,
      menuFechaPago: false,
      // Modal Lista de Espera
      modalListaEspera: {
        visible: false,
        tipoProceso: '',
        validas: 0,
        erroresEstado: [],
        preview: null,
        cargando: false,
        ejecutando: false,
      },
      // Modal Beneficiario
      modalBeneficiario: {
        visible: false,
        erroresEstado: [],
        form: {
          resolucion_lista_espera_numero: '',
          resolucion_lista_espera_fecha: null,
          resolucion_beneficiario_numero: '',
          resolucion_beneficiario_fecha: null,
          fecha_publicacion_diario_oficial: null,
        },
        preview: null,
        cargando: false,
        ejecutando: false,
      },
      // Modal Pagado
      modalPagado: {
        visible: false,
        erroresEstado: [],
        archivo: null,
        form: {
          resolucion_pago_numero: '',
          resolucion_pago_fecha: null,
          fecha_pago: null,
        },
        preview: null,
        cargando: false,
        ejecutando: false,
      },
    }
  },
  computed: {
    headers() {
      return [
        { text: 'RUT', value: 'rut', sortable: false },
        { text: 'Nombre', value: 'nombre_completo', sortable: false },
        { text: 'Municipalidad', value: 'municipalidad', sortable: false },
        { text: 'Sector', value: 'sector', sortable: false },
        { text: 'Estado', value: 'estado', sortable: false },
        { text: 'Prelación', value: 'numero_prelacion', sortable: false },
        { text: 'Fecha Nacimiento', value: 'fecha_nacimiento', sortable: false },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' },
      ]
    },
    estadosDisponibles() {
      return [
        { text: 'Enviada', value: 'enviada' },
        { text: 'Observada', value: 'observada' },
        { text: 'Validada', value: 'validada' },
        { text: 'Lista de Espera', value: 'lista_espera' },
        { text: 'Beneficiario', value: 'beneficiario' },
        { text: 'Dejación', value: 'dejacion' },
        { text: 'Desiste', value: 'desiste' },
        { text: 'Desiste Confirmado', value: 'desiste_confirmado' },
        { text: 'Cese de Funciones', value: 'cese_funciones' },
        { text: 'Cese Confirmado', value: 'cese_confirmado' },
        { text: 'Fallecimiento', value: 'fallecimiento' },
        { text: 'Fallecimiento Confirmado', value: 'fallecimiento_confirmado' },
        { text: 'Pagado', value: 'pagado' },
        { text: 'Otros', value: 'otros' },
        { text: 'Solicitud: Desiste → Dejación', value: 'desiste_solicita_dejacion' },
        { text: 'Solicitud: Dejación → Desiste', value: 'dejacion_solicita_desiste' },
        { text: 'Solicitud: Retorno a Cese de Funciones', value: 'cese_confirmado_solicita_retorno' },
      ]
    },
    sectoresDisponibles() {
      return [
        { text: 'Municipal', value: 'municipal' },
        { text: 'Cementerio', value: 'cementerio' },
      ]
    },
    esSubdere() {
      return this.$auth.can(['gestor-subdere-incentivo-retiro'])
    },
    tiposProceso() {
      return ['art-88']
    },
    modalBeneficiarioValido() {
      const f = this.modalBeneficiario.form
      return (
        f.resolucion_lista_espera_numero &&
        f.resolucion_lista_espera_fecha &&
        f.resolucion_beneficiario_numero &&
        f.resolucion_beneficiario_fecha &&
        f.fecha_publicacion_diario_oficial
      )
    },
    modalPagadoValido() {
      const f = this.modalPagado.form
      return f.resolucion_pago_numero && f.resolucion_pago_fecha && f.fecha_pago
    },
  },
  mounted() {
    this.cargarBeneficiarios()
    if (this.esSubdere) {
      this.cargarMunicipalidades()
    }
  },
  methods: {
    async cargarBeneficiarios() {
      this.cargando = true
      try {
        const { page = 1, itemsPerPage = 15 } = this.opciones
        const params = {
          page,
          per_page: itemsPerPage,
          ...this.filtros,
        }

        const { data } = await apiClient.get('/tramites/incentivos-retiro/asignacion/beneficiarios', { params })

        this.beneficiarios = data.data
        this.totalBeneficiarios = data.total

        // Resincroniza la selección con los datos frescos (por id), evitando que
        // queden referencias a objetos obsoletos con estado/cumple_requisitos viejos.
        const idsSeleccionados = new Set(this.seleccionadas.map((p) => p.id))
        this.seleccionadas = this.beneficiarios.filter((p) => idsSeleccionados.has(p.id))
      } catch (error) {
        notificarErrorResponse(error, 'Error al cargar beneficiarios')
      } finally {
        this.cargando = false
      }
    },
    async cargarMunicipalidades() {
      try {
        const { data } = await apiClient.get('usuarios/instituciones', { params: { tipo: 2 } })
        this.municipalidades = data.data || []
      } catch (error) {
        // silenciar
      }
    },
    seleccionarPrimerasN() {
      const n = Math.min(this.seleccionarPrimeras, this.beneficiarios.length)
      this.seleccionadas = this.beneficiarios.slice(0, n)
    },
    toggleOrdenPrelacion() {
      this.filtros.ordenar_prelacion = !this.filtros.ordenar_prelacion
      this.cargarBeneficiarios()
    },

    // ─── Abrir modal según proceso ───────────────────────────────
    abrirModalProceso(proceso) {
      const config = ESTADOS_REQUERIDOS[proceso]
      const validas = []
      const errores = []

      this.seleccionadas.forEach((p) => {
        const estadoOk = config.estados.includes(p.estado)
        const cumpleOk = !config.requiereCumple || p.cumple_requisitos === true
        if (estadoOk && cumpleOk) {
          validas.push(p)
        } else {
          errores.push(p)
        }
      })

      if (proceso === 'lista_espera') {
        this.modalListaEspera.visible = true
        this.modalListaEspera.validas = validas.length
        this.modalListaEspera.erroresEstado = errores
        this.modalListaEspera.preview = null
        this.modalListaEspera.tipoProceso = ''
      }

      if (proceso === 'beneficiario') {
        this.modalBeneficiario.visible = true
        this.modalBeneficiario.erroresEstado = errores
        this.modalBeneficiario.preview = null
        this.modalBeneficiario.form = {
          resolucion_lista_espera_numero: '',
          resolucion_lista_espera_fecha: null,
          resolucion_beneficiario_numero: '',
          resolucion_beneficiario_fecha: null,
          fecha_publicacion_diario_oficial: null,
        }
      }

      if (proceso === 'pagado') {
        this.modalPagado.visible = true
        this.modalPagado.erroresEstado = errores
        this.modalPagado.archivo = null
        this.modalPagado.preview = null
        this.modalPagado.form = {
          resolucion_pago_numero: '',
          resolucion_pago_fecha: null,
          fecha_pago: null,
        }
      }
    },
    cerrarModal(proceso) {
      if (proceso === 'lista_espera') this.modalListaEspera.visible = false
      else if (proceso === 'beneficiario') this.modalBeneficiario.visible = false
      else if (proceso === 'pagado') this.modalPagado.visible = false
    },

    // ─── IDs válidos según proceso ───────────────────────────────
    getIdsValidos(proceso) {
      const config = ESTADOS_REQUERIDOS[proceso]
      return this.seleccionadas
        .filter((p) => {
          const estadoOk = config.estados.includes(p.estado)
          const cumpleOk = !config.requiereCumple || p.cumple_requisitos === true
          return estadoOk && cumpleOk
        })
        .map((p) => p.id)
    },

    // ─── Preview ─────────────────────────────────────────────────
    async previewProceso(proceso) {
      const modal = proceso === 'lista_espera' ? this.modalListaEspera
        : proceso === 'beneficiario' ? this.modalBeneficiario
        : this.modalPagado

      modal.cargando = true
      try {
        let payload = {}
        let url = ''

        if (proceso === 'lista_espera') {
          url = '/tramites/incentivos-retiro/asignacion/procesos/lista-espera/preview'
          payload = {
            postulacion_ids: this.getIdsValidos('lista_espera'),
            tipo_proceso: this.modalListaEspera.tipoProceso,
          }
        } else if (proceso === 'beneficiario') {
          url = '/tramites/incentivos-retiro/asignacion/procesos/beneficiario/preview'
          payload = {
            tipo_proceso: this.filtros.tipo_proceso,
            postulacion_ids: this.getIdsValidos('beneficiario'),
            // prelacion_inicio: this.filtros.prelacion_min,
            // prelacion_fin: this.filtros.prelacion_max,
            ...this.modalBeneficiario.form,
          }
        } else {
          url = '/tramites/incentivos-retiro/asignacion/procesos/pagado/preview'
          const formData = new FormData()
          formData.append('archivo', this.modalPagado.archivo)
          const { data } = await apiClient.post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          modal.preview = data
          modal.cargando = false
          return
        }

        const { data } = await apiClient.post(url, payload)
        modal.preview = data
      } catch (error) {
        notificarErrorResponse(error, 'Error al generar vista previa')
      } finally {
        modal.cargando = false
      }
    },

    // ─── Ejecutar ────────────────────────────────────────────────
    async ejecutarProceso(proceso) {
      const modal = proceso === 'lista_espera' ? this.modalListaEspera
        : proceso === 'beneficiario' ? this.modalBeneficiario
        : this.modalPagado

      modal.ejecutando = true
      try {
        let payload = {}
        let url = ''

        if (proceso === 'lista_espera') {
          url = '/tramites/incentivos-retiro/asignacion/procesos/lista-espera/ejecutar'
          payload = {
            postulacion_ids: this.getIdsValidos('lista_espera'),
            tipo_proceso: this.modalListaEspera.tipoProceso,
          }
        } else if (proceso === 'beneficiario') {
          url = '/tramites/incentivos-retiro/asignacion/procesos/beneficiario/ejecutar'
          payload = {
            tipo_proceso: this.filtros.tipo_proceso,
            postulacion_ids: this.getIdsValidos('beneficiario'),
            // prelacion_inicio: this.filtros.prelacion_min,
            // prelacion_fin: this.filtros.prelacion_max,
            ...this.modalBeneficiario.form,
          }
        } else {
          url = '/tramites/incentivos-retiro/asignacion/procesos/pagado/ejecutar'
          payload = {
            pares: this.modalPagado.preview.pares,
            ...this.modalPagado.form,
          }
        }

        const { data } = await apiClient.post(url, payload)
        notificar({ message: data.message, severity: 'success' })

        modal.visible = false
        this.seleccionadas = []
        await this.cargarBeneficiarios()
      } catch (error) {
        notificarErrorResponse(error, 'Error al ejecutar proceso')
      } finally {
        modal.ejecutando = false
      }
    },

    // ─── Excel general ───────────────────────────────────────────
    async exportarExcel() {
      this.exportando = true
      try {
        const params = { per_page: 10000, ...this.filtros }
        const { data } = await apiClient.get('/tramites/incentivos-retiro/asignacion/beneficiarios', { params })
        const items = data.data || []

        if (items.length === 0) {
          notificar({ message: 'No hay datos para exportar', severity: 'warning' })
          return
        }

        const nuevosItems = []

        items.forEach(item => {
          const totalTrabajado = this.totalTrabajado(item.historial_laboral || [])
          const periodoMismaMunicipalidad = totalTrabajado.periodos.filter(p => +p.municipalidadId === +item.certificado?.municipalidad_id)
          const periodosOtraMunicipalidad = totalTrabajado.periodos.filter(p => +p.municipalidadId !== +item.certificado?.municipalidad_id)
          const totalPeriodos = totalTrabajado.total
          const periodoResumenOtraMunicipalidad = this.sumarPeriodos(periodosOtraMunicipalidad)

          nuevosItems.push({
            ...item,
            periodoMismaMunicipalidad: periodoMismaMunicipalidad.length > 0 ? periodoMismaMunicipalidad[0] : null,
            periodosOtraMunicipalidad: periodoResumenOtraMunicipalidad.total,
            totalPeriodos: totalPeriodos
          })
        })

        // ordena items por numero_prelacion ascendente, colocando los que no tienen prelación al final
        nuevosItems.sort((a, b) => {
          if (a.numero_prelacion && b.numero_prelacion) {
            return a.numero_prelacion - b.numero_prelacion
          } else if (a.numero_prelacion) {
            return -1
          } else if (b.numero_prelacion) {
            return 1
          } else {
            return 0
          }
        })

        const rows = nuevosItems.map((item) => ({
          'N. Prelación': item.numero_prelacion || '-',
          'Nombre de Proceso': item.certificado.tipo === 'ley_21724_menor_75' ? 'Ley 21.724 - Menor de 75 años' : 'Ley 21.724 - Mayor de 75 años',
          'Tramo': item.certificado.tramo || '-',
          'RUT Municipalidad': item.certificado ? item.certificado.municipalidad_id : '-',
          'Nombre de Municipalidad': this.getMunicipalidadNombre(item),
          'RUT Postulante': item.rut || '',
          'Nombres Postulante': item.nombres || '',
          'Apellido Paterno Postulante': item.apellido_paterno || '',
          'Apellido Materno Postulante': item.apellido_materno || '',
          'Fecha de Nacimiento': item.fecha_nacimiento ? this.formatearFecha(item.fecha_nacimiento) : '-',
          'Sexo': item.sexo || '-',
          'Email': item.correo_electronico || '-',
          'Dirección': item.direccion || '-',
          'Numero': item.numero_direccion || '-',
          'Comuna': item.comuna || '-',
          'Antigüedad Día': item.periodoMismaMunicipalidad?.dias || 0,
          'Antigüedad Mes': item.periodoMismaMunicipalidad?.meses || 0,
          'Antigüedad Año': item.periodoMismaMunicipalidad?.anios || 0,
          'Otra Antigüedad Día': item.periodosOtraMunicipalidad?.dias || 0,
          'Otra Antigüedad Mes': item.periodosOtraMunicipalidad?.meses || 0,
          'Otra Antigüedad Año': item.periodosOtraMunicipalidad?.anios || 0,
          'Total Antigüedad en la administración Municipal': item.totalPeriodos?.anios || 0,
          'Tipo de Postulación': this.getSectorTexto(item.sector) || '-',
          'Causa de Cese': item.causa_cese || '-',
          'Estado Cumplimiento': item.cumple_requisitos === true ? 'Cumple' : 'No Cumple',
          'Calidad jurídica': item.calidad_juridica === 'cementerio' ? 'codigo del trabajo' : item.calidad_juridica,
          'Estamento': item.sector === 'cementerio' ? item.codigo_trabajo_cementerio : item.estamento || '-',
          'Grado': item.grado || '-',
          'Jornada': +item.jornada_trabajo || '-',
          'Dias licencia medica': +item.dias_licencias_medicas,
          'Solicita bonificación retiro voluntario': item.solicita_bonificacion_retiro ? 'Sí' : 'No',
          'Nro. meses Bonificación retiro voluntario': +item.meses_retiro_voluntario || '-',
          'Monto Bonificación retiro voluntario': +item.monto_retiro_voluntario || '-',
          'Solicita bonificación complementaria': item.solicita_bonificacion_complementaria_retiro ? 'Sí' : 'No',
          'Nro. meses Bonificación complementaria': +item.meses_retiro_complementario || '-',
          'Monto Bonificación complementaria': +item.monto_retiro_complementario || '-',
          'Solicita bonificación adicional': item.solicita_bonificacion_adicional ? 'Sí' : 'No',
          'Años Bonificación adicional': +item.anios_servicio_bonificacion_adicional,
          'Monto (UF) Bonificación adicional ': +item.monto_uf_bonificacion_adicional,
          'Solicita Bono Antiguedad': item.solicita_bono_antiguedad ? 'Sí' : 'No',
          'Años Bono antiguedad ': +item.anios_antiguedad,
          'Monto (UF) Bono antigüedad': +item.monto_uf_anios_antiguedad,
          'Solicita bono Trabajo Pesado': item.tuvo_trabajo_pesado ? 'Sí' : 'No',
          'Años de Trabajo Pesado': +item.anios_trabajo_pesado,
          'Monto (UF) Trabajo Pesado': +item.monto_uf_trabajo_pesado,
          'Fecha Recepción': item.fecha_recepcion ? this.formatearFecha(item.fecha_recepcion) : '-',
          'Fecha creación Postulación': item.created_at ? this.formatearFecha(item.created_at) : '-',
          'Nombre Completo Encargado (Registrador)': item.datos?.creado_por?.nombre || '-',
          'Fono Encargado': item.datos?.creado_por?.telefono || '-',
          'Email Encargado': item.datos?.creado_por?.email || '-',
          // 'Estado Postulación': this.getEstadoTexto(item.estado),
          // 'Tipo Proceso': item.tipo_proceso || '-',
          // 'Última Actualización': this.formatearFecha(item.updated_at),
        }))

        // const ws = XLSX.utils.json_to_sheet(rows)
        const ws = XLSX.utils.aoa_to_sheet([
          [
            ...Array(14).fill(''),
            'Antigüedad en la Municipalidad Empleadora', '', '',
            'Antigüedad en Otras Municipalidades', '', '', '',
            ...Array(29).fill('')
          ],
        ])

        XLSX.utils.sheet_add_json(ws, rows, { origin: 'A2' })

        // Fusiona las celdas de la primera fila de cabecera
        ws['!merges'] = [
          { s: { r: 0, c: 14 }, e: { r: 0, c: 16 } },
          { s: { r: 0, c: 17 }, e: { r: 0, c: 19 } },
        ]

        // Calcular el ancho de las columnas basándose en el contenido
        const columnWidths = []
        const headers = Object.keys(rows[0] || {})

        headers.forEach((header, colIndex) => {
          // Ancho del header
          let maxWidth = header.length

          // Revisar el contenido de cada fila para esta columna
          rows.forEach(row => {
            const cellValue = String(row[header] || '')
            maxWidth = Math.max(maxWidth, cellValue.length)
          })

          // Agregar un poco de padding y límite máximo
          columnWidths.push({ wch: Math.min(maxWidth + 2, 50) })
        })

        ws['!cols'] = columnWidths

        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Beneficiarios')

        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        saveAs(blob, `beneficiarios_asignacion_${format(new Date(), 'YYYYMMDD_HHmm')}.xlsx`)
        notificar({ message: `Excel generado con ${items.length} registros`, severity: 'success' })
      } catch (error) {
        notificarErrorResponse(error, 'Error al exportar Excel')
      } finally {
        this.exportando = false
      }
    },

    // ─── Navegación ──────────────────────────────────────────────
    irAlDetalle(item) {
      this.$router.push({ name: 'asignacion-beneficiario-detalle', params: { id: item.id } })
    },

    // ─── Helpers ─────────────────────────────────────────────────
    getNombreCompleto(item) {
      return [item.nombres, item.apellido_paterno, item.apellido_materno].filter(Boolean).join(' ')
    },
    getMunicipalidadNombre(item) {
      const id = item.certificado?.municipalidad_id
      if (!id) return '-'
      const muni = municipalidades[id]
      return muni ? muni.nombre : id
    },
    getMunicipalidadNombrePorId(id) {
      if (!id) return '-'
      const muni = municipalidades[id]
      return muni ? muni.nombre : id
    },
    getEstadoColor(estado) {
      const colores = {
        enviada: 'deep-purple',
        observada: 'amber darken-2',
        validada: 'light-blue',
        lista_espera: 'orange',
        beneficiario: 'blue',
        dejacion: 'purple',
        desiste: 'red lighten-1',
        desiste_confirmado: 'red darken-2',
        cese_funciones: 'teal',
        cese_confirmado: 'teal darken-2',
        fallecimiento: 'brown',
        fallecimiento_confirmado: 'brown darken-2',
        pagado: 'green',
        otros: 'blue-grey darken-1',
        desiste_solicita_dejacion: 'amber darken-3',
        dejacion_solicita_desiste: 'amber darken-3',
        cese_confirmado_solicita_retorno: 'amber darken-3',
      }
      return colores[estado] || 'grey'
    },
    getEstadoTexto(estado) {
      const textos = {
        enviada: 'Enviada',
        observada: 'Observada',
        validada: 'Validada',
        lista_espera: 'Lista de Espera',
        beneficiario: 'Beneficiario',
        dejacion: 'Dejación',
        desiste: 'Desiste',
        desiste_confirmado: 'Desiste Confirmado',
        cese_funciones: 'Cese de Funciones',
        cese_confirmado: 'Cese Confirmado',
        fallecimiento: 'Fallecimiento',
        fallecimiento_confirmado: 'Fallecimiento Confirmado',
        pagado: 'Pagado',
        otros: 'Otros',
        desiste_solicita_dejacion: 'Solicitud: Desiste → Dejación',
        dejacion_solicita_desiste: 'Solicitud: Dejación → Desiste',
        cese_confirmado_solicita_retorno: 'Solicitud: Retorno a Cese de Funciones',
      }
      return textos[estado] || estado
    },
    getSectorColor(sector) {
      return sector === 'cementerio' ? 'deep-purple lighten-4' : 'blue lighten-4'
    },
    getSectorTexto(sector) {
      const textos = {
        municipal: 'Municipal',
        cementerio: 'Código del Trabajo',
      }
      return textos[sector] || sector || '-'
    },
    formatearFecha(fecha) {
      if (!fecha) return '-'
      // Extrae solo la parte de la fecha (YYYY-MM-DD)
      const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(fecha)
      if (!match) return '-'
      const [, year, month, day] = match
      return `${day}/${month}/${year}`
    },
    totalTrabajado(historialLaboral) {
      const postulacionAgrupada = Object.groupBy(historialLaboral, ({ municipalidad_id: municipalidadId }) => municipalidadId)

      const existePeriodoConMasDe5Anios = historialLaboral.some(
        trabajo => trabajo.trabajado && trabajo.trabajado.anios >= 5
      )

      const resumenPeriodos = {}
      Object.entries(postulacionAgrupada).forEach(([municipalidadId, trabajos]) => {
        if (!resumenPeriodos[municipalidadId]) {
          resumenPeriodos[municipalidadId] = {anios: 0, meses: 0, dias: 0}
        }

        let trabajosFiltrados = trabajos

        if (!existePeriodoConMasDe5Anios) {
          trabajosFiltrados = trabajos.filter(trabajo =>
            trabajo.trabajado && trabajo.trabajado.anios >= 1
          )
        }

        trabajosFiltrados.forEach(trabajo => {
          let totalAnios = resumenPeriodos[municipalidadId].anios
          let totalMeses = resumenPeriodos[municipalidadId].meses
          let totalDias = resumenPeriodos[municipalidadId].dias

          if (trabajo.trabajado) {
            totalAnios += trabajo.trabajado.anios || 0
            totalMeses += trabajo.trabajado.meses || 0
            totalDias += trabajo.trabajado.dias || 0
          }

          if (totalDias >= 30) {
            totalMeses += Math.floor(totalDias / 30)
            totalDias = totalDias % 30
          }

          if (totalMeses >= 12) {
            totalAnios += Math.floor(totalMeses / 12)
            totalMeses = totalMeses % 12
          }

          resumenPeriodos[municipalidadId].anios = totalAnios
          resumenPeriodos[municipalidadId].meses = totalMeses
          resumenPeriodos[municipalidadId].dias = totalDias
        })

        const municipalidad = this.municipalidades.find(m => m.id === +municipalidadId)
        const nombreMunicipalidad = municipalidad ? municipalidad.nombre : 'Municipalidad no encontrada'
        resumenPeriodos[municipalidadId].municipalidadId = municipalidadId

        resumenPeriodos[municipalidadId].nombre = nombreMunicipalidad
      })

      let totalAniosResumen = 0
      let totalMesesResumen = 0
      let totalDiasResumen = 0

      Object.values(resumenPeriodos).forEach(periodo => {
        totalAniosResumen += periodo.anios
        totalMesesResumen += periodo.meses
        totalDiasResumen += periodo.dias
      })

      // Se aproxima que 30 dias corresponden a un mes
      if (totalDiasResumen >= 30) {
        totalMesesResumen += Math.floor(totalDiasResumen / 30)
        totalDiasResumen = totalDiasResumen % 30
      }

      if (totalMesesResumen >= 12) {
        totalAniosResumen += Math.floor(totalMesesResumen / 12)
        totalMesesResumen = totalMesesResumen % 12
      }

      return {
        periodos: Object.values(resumenPeriodos),
        total: {
          anios: totalAniosResumen,
          meses: totalMesesResumen,
          dias: totalDiasResumen
        }
      }
    },
    sumarPeriodos(periodos) {
      let totalAniosResumen = 0
      let totalMesesResumen = 0
      let totalDiasResumen = 0

      Object.values(periodos).forEach(periodo => {
        totalAniosResumen += periodo.anios
        totalMesesResumen += periodo.meses
        totalDiasResumen += periodo.dias
      })

      // Se aproxima que 30 dias corresponden a un mes
      if (totalDiasResumen >= 30) {
        totalMesesResumen += Math.floor(totalDiasResumen / 30)
        totalDiasResumen = totalDiasResumen % 30
      }

      if (totalMesesResumen >= 12) {
        totalAniosResumen += Math.floor(totalMesesResumen / 12)
        totalMesesResumen = totalMesesResumen % 12
      }

      return {
        total: {
          anios: totalAniosResumen,
          meses: totalMesesResumen,
          dias: totalDiasResumen
        }
      }
    }
  },
}
</script>

<style scoped>
.v-data-table tbody tr {
  cursor: pointer;
}
</style>
